import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/security'

export const securityService = {
    listUsersByRole,
    listRolesByUser,
    listSupervisors,
};

function listUsersByRole(id) {
    return utilHelper.doRequest(`${relativeUrl}/listUsersByRole/${id}`, 'POST')
}

function listRolesByUser(id) {
    return utilHelper.doRequest(`${relativeUrl}/listRolesByUser/${id}`, 'POST')
}

function listSupervisors() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/listSupervisors`, 'GET', {showAlert:false})
}